import React from 'react';
import { I18n } from 'react-redux-i18n';

const passwordStrengthIndicatorItem = ({ isValid, text }) => (
  <li
    style={{
      listStyle: 'none', marginTop: '6px', marginBottom: '4px', fontSize: '0.9rem',
    }}
    className={isValid ? 'text-success' : ''}
  >
    {text}
  </li>
);

const passwordStrengthIndicator = ({
  validity: {
    minChar, number, upperCase, specialChar,
  },
  passwordEqual,
}) => (
  <div className="text-left">
    <p
      className="text-primary"
      style={{
        marginTop: '2px', marginBottom: '10px', fontSize: '1.1rem', fontWeight: 600,
      }}
    >
      {I18n.t('passwordIndicatorTitle' /* Política de Senha */)}
    </p>
    <p
      className="text-primary"
      style={{
        marginTop: '2px', marginBottom: '8px', fontSize: '0.9rem',
      }}
    >
      {I18n.t('passwordIndicatorSubTitle' /* A senha deverá conter */)}
    </p>
    <ul
      className="text-danger"
    >
      {passwordStrengthIndicatorItem({
        isValid: minChar,
        text: I18n.t('passwordIndicatorMinChar' /* No mínimo 12 caracteres */),
      })}
      {passwordStrengthIndicatorItem({
        isValid: number,
        text: I18n.t('passwordIndicatorNumber' /* Dígitos (0-9) */),
      })}
      {passwordStrengthIndicatorItem({
        isValid: upperCase,
        text: I18n.t('passwordIndicatorUpperCase' /* Pelo menos uma letra maiúscula (A-Z) */),
      })}
      {passwordStrengthIndicatorItem({
        isValid: specialChar,
        text: I18n.t('passwordIndicatorSpecialChar' /* Pelo menos um caracter especial (!@#) */),
      })}
      {passwordStrengthIndicatorItem({
        isValid: passwordEqual,
        text: I18n.t('passwordIndicatorPasswordEqual' /* Senhas iguais */),
      })}
    </ul>
  </div>
);

export default passwordStrengthIndicator;
